module.exports = __webpack_public_path__ + "static/media/2_duplex_B_yellow_square.26d6def6.png";